<template>
  <div class="generic-tile product-tile">
    <div class="radio-selection"></div>
    <div class="wrapp-first">
      <slot name="first">
        <img-product
        class="wrapp-media"
        :imgPath="productImage"
        :alt="product.name"
        size="MD"
        />
      </slot>
    </div>
    <div class="wrapp-content">
      <slot name="content">
        <div class="value value-sku">{{product.sku}}</div>
        <div class="value value-name">{{product.name}}</div>
      </slot>
    </div>
    <div class="wrapp-last">
      <slot name="last">
        <div class="wrapp-price">
          <span class="product-qty">{{qty}} x </span>
          <div class="price-calculation ml-2">
            <span class="product-price_final mr-2">{{ price | price($store) }}</span>
            <span class="product-price_original" v-show="originalPrice">{{ originalPrice | price($store) }}</span>
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import Config from 'config'
import ImgProduct from 'theme/components/Product/Image'
import { resizeService } from '@/helpers/utils'
import GenericTabTile from 'theme/components/Checkout/PriceAdjustements/Tabs/Tile/GenericTabTile'

export default {
  name: 'ProductTabTile',
  mixins: [GenericTabTile],
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    productImage () {
      let imageUrl = this.product && this.product.extension_attributes.image_url
      const { width, quality } = Config.Theme.swatchOpt.imageOpt
      if (imageUrl) {
        return `${resizeService(imageUrl)}?width=${width}&q=${quality}`
      }
      return ''
    },
    originalPrice () {
      if (this.product && this.product.extension_attributes.product_base_price) {
        // base price is the unitary price
        // check is value using product.price
        let basePrice = this.product.extension_attributes.product_base_price
        let productPrice = this.product.price
        if (productPrice !== basePrice) {
          // show original price as well
          return this.product.extension_attributes.product_base_price
        } else {
          return 0
        }
      }
      return 0
    },
    price () {
      return this.product.price
    },
    qty () {
      return this.product.qty
    }
  },
  components: {
    ImgProduct,
    GenericTabTile
  }
}
</script>
